export default "__VITE_ASSET__COBjUC78__"